module.exports = __webpack_public_path__ + "static/logo-73680130e78fc6f26ecba16c2254929d.png";